import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OffersRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page immediately
    navigate('/', { replace: true });
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default OffersRedirect;